const ARGENTINE_GROUPED_INTEGER_PATTERN = /^-?\d{1,3}(?:\.\d{3})+$/;
export function parseArgentineNumber(value) {
    const compactValue = value.trim().replace(/\s/g, "");
    if (!compactValue) {
        return undefined;
    }
    const normalizedValue = compactValue.includes(",")
        ? compactValue.replace(/\./g, "").replace(",", ".")
        : ARGENTINE_GROUPED_INTEGER_PATTERN.test(compactValue)
            ? compactValue.replace(/\./g, "")
            : compactValue;
    const parsedValue = Number(normalizedValue);
    return Number.isFinite(parsedValue) ? parsedValue : undefined;
}
export function parseArgentineAmountToCents(value) {
    const pesos = parseArgentineNumber(value);
    return pesos === undefined ? undefined : Math.round(pesos * 100);
}
export function formatNumber(value, type = "float", decimals = 2) {
    if (type === "whole") {
        return value.toLocaleString("es-AR", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
    }
    const floatValue = value / 100;
    const hasCents = Math.abs(value) % 100 !== 0;
    return floatValue.toLocaleString("es-AR", {
        minimumFractionDigits: hasCents ? decimals : 0,
        maximumFractionDigits: decimals,
    });
}
export function formatQuantity(value) {
    return value.toLocaleString("es-AR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
    });
}
export function calculateItemTax(unitPrice, quantity, taxRateId, discount, taxInclusive = true) {
    const lineTotal = Math.round(unitPrice * quantity);
    let discountAmount = 0;
    if (discount) {
        if (discount.type === "percentage") {
            discountAmount = Math.round(lineTotal * (discount.value / 100));
        }
        else {
            discountAmount = discount.value;
        }
    }
    const lineTotalAfterDiscount = lineTotal - discountAmount;
    const taxRateDecimal = taxRateId / 100;
    if (taxInclusive) {
        const subtotal = Math.round(lineTotalAfterDiscount / (1 + taxRateDecimal));
        const taxAmount = lineTotalAfterDiscount - subtotal;
        return { subtotal, taxAmount, total: lineTotalAfterDiscount };
    }
    const subtotal = lineTotalAfterDiscount;
    const taxAmount = Math.round(subtotal * taxRateDecimal);
    const total = subtotal + taxAmount;
    return { subtotal, taxAmount, total };
}
export function calculateTotals(items, fee) {
    const itemsSubtotal = items.reduce((sum, item) => sum + item.subtotal, 0);
    const itemsTaxAmount = items.reduce((sum, item) => sum + item.taxAmount, 0);
    const itemsTotal = items.reduce((sum, item) => sum + item.total, 0);
    let feeAmount = 0;
    if (fee) {
        if (fee.type === "percentage") {
            feeAmount = Math.round(itemsTotal * (fee.value / 100));
        }
        else {
            feeAmount = fee.value;
        }
    }
    return {
        subtotal: itemsSubtotal,
        taxAmount: itemsTaxAmount,
        total: itemsTotal + feeAmount,
    };
}
export function applyDiscount(amount, discount) {
    return discount.type === "percentage"
        ? Math.round(amount * (discount.value / 100))
        : discount.value;
}
